const state = {
	version: '2.2.26'
};


const getters = {
	version(state) {
		return state.version;
	}
};

// Mutations"
const mutations = {

};

// Actions
const actions = {

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
